export const IdentificationType = {
  CB_IDENTIFICACION_RUT: 'RUT',
  CB_IDENTIFICACION_RUC: 'RUC',
  CB_IDENTIFICACION_DNI: 'DNI',
  CB_IDENTIFICACION_RFCPF: 'RFC Persona física',
  CB_IDENTIFICACION_RFCPM: 'RFC Persona moral',
  CB_IDENTIFICACION_CPF: 'CPF',
  CB_IDENTIFICACION_CNPJ: 'CNPJ',
  CB_IDENTIFICACION_OTHER: 'Otro',
};

export const ValueIdentificationType = {
  CB_IDENTIFICACION_CNPJ: 'CB_TIPO-PERSONA_PJ',
  CB_IDENTIFICACION_RFCPM: 'CB_TIPO-PERSONA_PJ',
  CB_IDENTIFICACION_RFCPF: 'CB_TIPO-PERSONA_PN',
  CB_IDENTIFICACION_CPF: 'CB_TIPO-PERSONA_PN',
  CB_IDENTIFICACION_DNI: 'CB_TIPO-PERSONA_PN',
};
